import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProductDetailsComponent} from './product-details/product-details.component';
import {ProductLightGalleryComponent} from "../productv2/product-light-gallery/product-light-gallery.component";
import {ProductDetailComponent} from "../productv2/product-detail/product-detail.component";

const routes: Routes = [

	{
		path: ':category/:slug',
		component:ProductDetailsComponent
	},
	{
		path: 'gallery',
		component: ProductLightGalleryComponent
	},
	{
		path: 'v2/:category/:slug',
		component: ProductDetailComponent
	}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductDetailsRoutingModule { }
